<template>
  <div :id="dialogID" v-show="visible">
    <force-landscape :forceLandscape="needForceLandscape" style="z-index: 5">
      <template>
        <div class="mask"></div>
        <div
          class="dialog-content"
          :style="{
            width: width + 'vmax',
            height: width / 1.6 + 'vmax',
            'padding-top': showCloseBtn ? '10px' : '12px',
            'text-align': textAlign,
            backgroundImage: bgURL,
          }"
        >
          <div class="content">
            <p
              v-html="content"
              class="text"
              :style="{ color: textColor, height: textHeight + '%' }"
            ></p>
          </div>
          <div
            class="btn-group"
            style="font-size: 12px; left: 8px"
            :style="{
              bottom: showCloseBtn ? '20px' : '17px',
            }"
          >
            <div
              class="dialog-btn"
              :style="{
                backgroundImage: cancelURL,
                color: textColor,
                backgroundColor: cancelColor,
                width: btnWidth + 'px',
              }"
              v-if="cancel"
              @click="cancelFunc()"
            >
              {{ cancel }}
            </div>
            <div v-if="cancel" style="width: 18px"></div>
            <div
              class="dialog-btn"
              :style="{
                backgroundImage: confirmURL,
                color: textColor,
                backgroundColor: confirmColor,
                width: btnWidth + 'px',
              }"
              @click="confirmFunc()"
            >
              {{ confirm }}
            </div>
          </div>
        </div>
      </template>
    </force-landscape>
  </div>
</template>
<script>
import ForceLandscape from "@/components/layout/ForceLandscape.vue";
import { getCosH5Address, GameTextColor } from "@/constant";

export default {
  components: {
    ForceLandscape,
  },

  data() {
    return {
      visible: false,
      cancel: "",
      confirm: "confirm",
      content: "test",
      title: "",
      needForceLandscape: false,
      width: 40,
      btnWidth: 80,
      textAlign: "left",
      showCloseBtn: false,
      hover: false,
      bgURL: "",
      confirmURL: "",
      cancelURL: "",
      textColor: "#ffffff",
      confirmColor: "transparent",
      cancelColor: "transparent",
      dialogID: "default-dialog",
      textHeight: null,
    };
  },

  mounted() {
    this.initImageLoad();
  },

  methods: {
    initImageLoad() {
      const gameId = window.location.pathname.split("/").pop();
      getCosH5Address("modal-content", gameId).then(
        (data) => (this.bgURL = data)
      );
      getCosH5Address("cancel-btn", gameId).then(
        (data) => (this.cancelURL = data)
      );
      getCosH5Address("confirm-btn", gameId).then(
        (data) => (this.confirmURL = data)
      );
      this.textColor = GameTextColor[gameId]
        ? GameTextColor[gameId]
        : "#ffffff";
    },
    ifHover() {
      return this.hover;
    },

    setHover(value) {
      this.hover = value;
    },

    show() {
      this.visible = true;
    },

    // 取消,将promise断定为reject状态
    cancelFunc() {
      this.visible = false;
    },

    confirmFunc() {
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.dialog-content {
  position: fixed;
  box-sizing: border-box;
  padding: 20px;
  padding-left: 29px;
  padding-bottom: 40px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 50002;
  // background-color: #383838;
  // background-image: var(--modal-content-iconimg);
  // background-image: url("../../assets/hok/modal-content.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: contain;
  // max-height: 80vmin;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 85%;
    height: 75%;
    overflow: scroll;
    margin-left: 2px;
    // margin: 8vmin 2vmin 6vmin 3vmin;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
  }
  .text {
    white-space: pre-line;
    font-family: Verdana;
    font-size: 13px;
    color: #e1e2f3;
    margin: 0px;
    text-align: left;
  }
  .btn-group {
    display: flex;
    width: inherit;
    position: absolute;
    justify-content: center;
    right: 0;
    bottom: 10px;
    .btn {
      padding: 10px 20px;
      font-size: 14px;
      &:last-child {
        color: #76d49b;
      }
    }
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 50001;
  background: rgba(0, 0, 0, 0.5);
}

.dialog-btn {
  min-width: 80px;
  padding: 8px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-radius: 3px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-color: #523fff;
  // background-image: url("../../assets/hok/confirm-btn.png");
  color: #ffffff;
  font-size: 12px;
  font-family: Verdana;
  cursor: pointer;
}

.btn-cancel {
  min-width: 80px;
  // height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-radius: 19px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-image: url("../../assets/hok/cancel-btn.png");
  border-radius: 3px;
  padding: 0 1vmin;
  // background-color: #464450;
  // background-size: 100% 100%;
  color: #ffffff;
  font-size: 12px;
  font-family: Verdana;
  cursor: pointer;
}
.btn-affrim {
  min-width: 80px;
  padding: 8px 10px;
  // height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-radius: 19px;
  // background-color: #523fff;
  border-radius: 3px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-color: #523fff;
  // background-image: url("../../assets/hok/confirm-btn.png");
  color: #ffffff;
  font-size: 12px;
  font-family: Verdana;
  cursor: pointer;
}
.dialog-icon-close {
  position: absolute;
  right: 10px;
  font-size: 10px;
  top: 10px;
  cursor: pointer;
  color: #bbb;
  opacity: 0.6;
}
// .dialog-icon-close:hover {
//   color: #523fff;
// }

.dialog-title {
  text-align: center;
  color: white;
  font-size: 18px;
}
</style>